import { render, staticRenderFns } from "./UserRegionAppendForm.vue?vue&type=template&id=4841daba&"
import script from "./UserRegionAppendForm.vue?vue&type=script&lang=js&"
export * from "./UserRegionAppendForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports